import { getAnalytics } from "firebase/analytics";
import { getApp, getApps, initializeApp } from "firebase/app";
import {
    fetchAndActivate,
    getRemoteConfig,
    getValue,
    isSupported as isRemoteConfigSupported,
} from "firebase/remote-config";

const firebaseConfig = {
    apiKey: "AIzaSyDX86UXtUgjkFnvHdrlRK84_NrO47GFU7U",
    authDomain: "gprojecttz.firebaseapp.com",
    projectId: "gprojecttz",
    storageBucket: "gprojecttz.appspot.com",
    messagingSenderId: "1028890276521",
    appId: "1:1028890276521:web:d740819ec996b96aaf6fb8",
    measurementId: "G-W1HBDWTRD9"
};

const DEFAULT_API_TOKEN = "";
const DEFAULT_SUBSCRIPTION_PUT_TOKEN = "";

let remoteConfigInitPromise;
let cachedApiToken = DEFAULT_API_TOKEN;
let cachedSubscriptionPutToken = DEFAULT_SUBSCRIPTION_PUT_TOKEN;

export function initFirebaseApp() {
    if (getApps().length > 0) {
        return getApp();
    }
    return initializeApp(firebaseConfig);
}

export function initFirebaseAnalytics() {
    try {
        const app = initFirebaseApp();
        if (typeof window !== "undefined") {
            getAnalytics(app);
        }
    } catch (error) {
        console.warn("Firebase analytics not available", error);
    }
}

async function initRemoteConfig() {
    const isSupported = await isRemoteConfigSupported().catch(() => false);
    if (!isSupported) {
        return;
    }

    const app = initFirebaseApp();
    const remoteConfig = getRemoteConfig(app);

    remoteConfig.settings = {
        fetchTimeoutMillis: 10000,
        minimumFetchIntervalMillis: 60 * 60 * 1000,
    };
    remoteConfig.defaultConfig = {
        api_token: DEFAULT_API_TOKEN,
        subscription_put_token: DEFAULT_SUBSCRIPTION_PUT_TOKEN,
    };

    await fetchAndActivate(remoteConfig).catch((error) => {
        console.warn("Remote config fetch failed, using defaults", error);
    });

    const apiToken = getValue(remoteConfig, "api_token").asString();
    const subscriptionPutToken = getValue(remoteConfig, "subscription_put_token").asString();

    cachedApiToken = apiToken || DEFAULT_API_TOKEN;
    cachedSubscriptionPutToken = subscriptionPutToken || DEFAULT_SUBSCRIPTION_PUT_TOKEN;
}

export function initFirebaseServices() {
    initFirebaseAnalytics();
    if (!remoteConfigInitPromise) {
        remoteConfigInitPromise = initRemoteConfig();
    }
    return remoteConfigInitPromise;
}

export async function getApiToken() {
    await initFirebaseServices();
    return cachedApiToken;
}

export async function getSubscriptionPutToken() {
    await initFirebaseServices();
    return cachedSubscriptionPutToken;
}
